<!-- 网站首页 -->
<template>
  <div>
    <!-- 使用table标签实现页面布局 -->
    <table class="styled-table">
      <tr>
        <td colspan="4">
          <!-- 轮播图 -->
          <el-carousel height="400px">
            <el-carousel-item v-for="item in items" :key="item">
              <img :src="item" alt="轮播图" />
            </el-carousel-item>
          </el-carousel>
        </td>
      </tr>
      <tr>
        <td colspan="2">题库/文章</td>
        <td colspan="2"  class="more">
          <a href="/#/questionBank" class="gdcls">更多</a>
        </td>
      </tr>
      <!-- 题库/文章内容行 -->
      <tr>
        <td
            style="width: 300px"  v-for="item in resData.questBankList" :key="item.bankId"
          >
            <el-card
              shadow="hover"
              :body-style="{ padding: '0px' }"
              
            >
              <!-- 图片 -->
              <img v-bind:src="item.titleUrl" class="imags" @click="goDetails(item.bankId)" />
              <!-- 内容标题 -->
              <div style="padding: 14px">
                <div class="container">
                    <span class="ellipsis">{{ item.title }}</span>
                </div>

                <div class="bottom clearfix">
                  <time class="time">{{ item.createtime }}</time>
                </div>
              </div>
            </el-card>
          </td>
      </tr>
      <tr>
        <td colspan="2">精品项目</td>
        <td colspan="2" class="more">
          <a href="/#/delicacyProject" class="gdcls">更多</a>
        </td>
      </tr>
      <!-- 精品项目 -->
      <tr>
        <td
            style="width: 300px;"  v-for="item in resData.projectList" :key="item.projectId"
          >
            <el-card
              shadow="hover"
              :body-style="{ padding: '0px' }"
              
            >
              <!-- 图片 -->
              <img :src="item.coverUrl" class="imags" @click="projectDetail(item.projectId)"/>
              <!-- 内容标题 -->
              <div style="padding: 14px">
                <div class="container">
                  <span class="ellipsis">{{ item.title }}</span>
                </div>

                <div class="bottom clearfix">
                  <time class="time">{{ item.createtime }}</time>
                </div>
              </div>
            </el-card>
          </td>
        <!-- <td>2</td>
        <td>3</td>
        <td>4</td> -->
      </tr>
      <tr>
        <td colspan="2">资源下载</td>
        <td colspan="2" class="more">
          <a href="/#/resourceDownload" class="gdcls">更多</a>
        </td>
      </tr>
      <tr>
        <td
            style="width: 300px"  v-for="item in resData.resourceList" :key="item.resourceId"
          >
            <el-card
              shadow="hover"
              :body-style="{ padding: '0px' }"
              
            >
              <!-- 图片 -->
              <img :src="item.coverUrl" class="imags"  @click="downLoadGoDetails(item.resourceId)" />
              <!-- 内容标题 -->
              <div style="padding: 14px">
                <div class="container">
                  <span class="ellipsis">{{ item.resourceName }}</span>
                </div>

                <div class="bottom clearfix">
                  <time class="time">{{ item.createtime }}</time>
                </div>
              </div>
            </el-card>
          </td>
        <!-- <td>2</td>
        <td>3</td>
        <td>4</td> -->
      </tr>
    </table>


    <!-- 积分购买提示弹框 -->
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <span>是否花费：{{ needPriceData.price }} 积分</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="goDetails2(needPriceData.price)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
  </div>
</template>

<script>
// 导入封装好的发送请求类
import {
  findModelDate,
} from "@/api/home/home.js";
import {
  contentWhetherNeedPrice
} from "@/api/questionBank/questionBank.js";
export default {
  data() {
    return {
      // 轮播图图片地址
      items: [
        "https://cms-yunfuwuqi-1317095913.cos.ap-beijing.myqcloud.com/shareLunBoTu/1.png", 
        "https://cms-yunfuwuqi-1317095913.cos.ap-beijing.myqcloud.com/shareLunBoTu/2.png", 
        "https://cms-yunfuwuqi-1317095913.cos.ap-beijing.myqcloud.com/shareLunBoTu/3.png", 
        "https://cms-yunfuwuqi-1317095913.cos.ap-beijing.myqcloud.com/shareLunBoTu/4.png"
      ],
      // 三个模块中的数据
      resData:{},

      // 控制积分弹框展示
      dialogVisible: false,
          // 查询是否需要积分返回值
          needPriceData: {},
    };
  },
  created() {
    // 一进页面发送请求，获取数据
    this.getFindModelDate();
    
  },
  mounted() {
    // 组件挂载后执行的逻辑

  },
  methods: {
 // 跳转到详情页面-题库/文章
 async goDetails(bankId) {
      // 获取当前登录用户id
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      const userId = userData.data.userId;
      // 调用方法判断内容是否需要积分
      const needPrice = {
        bankId: bankId,
        userId: userId,
      };
      const res = await contentWhetherNeedPrice(needPrice);
      this.needPriceData.needState = res.data.needState;
      this.needPriceData.price = res.data.price;
      this.needPriceData.bankId = bankId;

      // 如果需要积分，则进行弹窗
      if (res.data.needState === 1) {
        this.dialogVisible = true;
      } else {
        // 进行页面跳转
        this.$router.push({
          path: `/questionBank/questionDetails/${bankId}`,
        });
      }
    },

    // 点击精品项目-跳转详情
    projectDetail(projectId){
      // 使用查询参数的方式跳转
      this.$router.push({ path: `/delicacyProject/delicacyProjectDetail/${projectId}` });

    },


    // 跳转到详情页面-资源下载
    async downLoadGoDetails(resourceId) {
      // 进行页面跳转
        this.$router.push({
          path: `/resourceDownload/resourceDownloadDetails/${resourceId}`,
        });
    },



    // 组件的方法
    async getFindModelDate() {
      // 调用封装好的请求方法
      const resData = await findModelDate();
      if(resData.status==200) {
        // 请求成功
        console.log("请求成功");
        this.resData = resData.data;  
      } else {
        // 请求失败
        this.$message.error(resData.message);
      }
     
    },

  },
  computed: {
    // 计算属性
    // 可以在这里定义一些计算属性供模板使用
  },
};
</script>

<style>
.styled-table {
  width: 70%;
  height: 100%;
  margin: 0 auto; /* 使表格居中 */
}
.styled-table td {
  /* border: 1px solid #0a0a0a; */
  padding: 10px; /* 设置内边距 */
}

img {
  width: 100%; /* 使图片宽度铺满 */
  height: auto;
}

/* 更多按钮-样式 */
.more {
  text-align: right; /* 右对齐 */
}
a {
  text-decoration: none; /* 去掉下划线 */
}

/**封面图片样式 */
.imags{
  width: 100%; /* 使图片宽度铺满 */
  height: 150px; /* 设置高度 */

}


/* 中间内容时间-样式 */
.time {
  font-size: 13px;
  color: #999;
}

/* span标签，标题内容超过两行，进行省略 */
.ellipsis {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
  }

  /**内容标题标签样式 */
.container{
  height: 40px; /* 设置高度 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出省略号 */

}

/* 更改文字链接样式 */
.gdcls{
  text-decoration: none; /* 去掉下划线 */
  margin-left: 10px; /* 左边距 */
}
</style>